import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch } from 'react-router'
import MainRoutes from './MainRoutes'
import RoutePrivate from './RoutePrivate'
import RoutePublic from './RoutePublic'
import SessionRoutes from './SessionRoutes'

const Navigation = () => {

    const user_data = useSelector(state => state.user)

    return (
        <React.Fragment>
            {
                user_data.user === null ?
                    <Switch>
                        <RoutePublic path="/" children={<SessionRoutes/>} />
                    </Switch> 
                    :
                    <Switch>
                        <RoutePrivate path="/" children={<React.Fragment><MainRoutes/></React.Fragment>} />
                    </Switch>
            }
        </React.Fragment>
    )
}

export default Navigation
